import { Component, OnInit, Input } from '@angular/core';
import { ConsumerModel } from '../../../models/consumer/consumer.model';
import { ConsumerInteractionService } from '../../../services/consumer-interaction.service';
import { MasonryItemModel } from '../../masonry/masonry.component';
import { ScreenMessagesItemComponent } from '../grid-item/screen-messages-item.component'
import { FriendlyDisconnectItemComponent } from '../grid-item/friendly-disconnect-item.component';

@Component({
  selector: 'consumer-detail-device',
  templateUrl: './consumer-detail-device.component.html',
})
export class ConsumerDetailDeviceComponent implements OnInit {

    public subscriptions: any[] = [];
    @Input() clientId: number;
    @Input() consumerId: string;
    constructor(private consumerInteractionService: ConsumerInteractionService) { }

    isSearching: boolean = false;
    results: any[] = [];
    page = 1;
    pageSize = 5;
    consumer: ConsumerModel = new ConsumerModel();
    masonryItems: MasonryItemModel[] = [];

    ngOnInit() {

        this.masonryItems = [
            {
                component: FriendlyDisconnectItemComponent,
            },
            {
                component: ScreenMessagesItemComponent,
            }
        ]

    }

}
